






















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { Location } from "vue-router";
import DrivewealthDocuments from "@/shared/components/investments/drivewealth/DrivewealthDocuments.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    DrivewealthDocuments,
    DrivewealthNavigation,
  }
})
export default class DocumentsPage extends Vue {
  @Prop() pageNumber: number;
  @Prop() routeToDrivewealthDocuments: (pageNumber: number) => Location;
  @Prop() routeToDrivewealthDocumentsV2: (
    dwAccountId: number, pageNumber: number,
    partnerId: number, username: string) => Location;
  @Prop({required: false}) username: string;
  @Prop({required: false}) partnerId: number;
  @Prop({required: false}) accountId: number;

  drivewealthStore = useDrivewealthStore();
}
